import React, { Component } from 'react'

import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class LiquidationTooltip extends Component {
    render() {
        return (
            <div>
                <FormattedMessage
                    id={`${LOCALE_PREFIX}.liquidationTooltipMain`}
                    values={{ strong: (chunks) => <strong>{chunks}</strong>, br: <br /> }}
                />
                <div className={cx('tooltip-liquidation-icon', 'na')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.liquidationNo`} />
                </div>
                <div className={cx('tooltip-liquidation-icon', 'liquidation-present')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.liquidationActive`} />
                </div>
                <div className={cx('tooltip-liquidation-icon', 'liquidation-past')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.liquidationHistorical`} />
                </div>
                <div>
                    <FormattedMessage id={`${LOCALE_PREFIX}.liquidationFooter`} />
                </div>
            </div>
        )
    }
}
